import React from 'react';
import {
  Box,
  Flex,
  Heading,
  Button,
  useColorMode,
  IconButton,
  Spacer,
  Progress,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

interface HeaderProps {
  apiUsage?: {
    used: number;
    limit: number;
    remaining: number;
  } | null;
  currentPlan?: 'free' | 'premium';
}

const Header: React.FC<HeaderProps> = ({ apiUsage, currentPlan = 'free' }) => {
  const { colorMode, toggleColorMode } = useColorMode();

  // カラーモード対応 - すべてのuseColorModeValueを最上位で定義
  const headerBg = useColorModeValue('brand.500', 'gray.800');
  const headerColor = useColorModeValue('white', 'gray.100');
  const progressBg = useColorModeValue('whiteAlpha.300', 'gray.600');
  const buttonBorderColor = useColorModeValue('whiteAlpha.600', 'gray.400');
  const buttonHoverBorderColor = useColorModeValue('whiteAlpha.800', 'gray.200');
  const hoverBg = useColorModeValue('whiteAlpha.200', 'gray.700');

  // API使用量のパーセンテージを計算
  const usagePercentage = apiUsage ? Math.round((apiUsage.used / apiUsage.limit) * 100) : 0;

  return (
    <Box as="header" bg={headerBg} color={headerColor} px={4} py={2}>
      <Flex maxW="container.xl" mx="auto" align="center">
        <Heading as="h1" size="md">
          Gemini Rewrite
        </Heading>
        
        <Spacer />
        
        <Flex gap={4} align="center">
          {apiUsage && (
            <Box>
              <Text fontSize="xs" mb={1}>API使用量: {usagePercentage}%</Text>
              <Progress 
                value={usagePercentage} 
                size="xs" 
                width="100px" 
                colorScheme={usagePercentage > 80 ? "red" : usagePercentage > 50 ? "yellow" : "green"} 
                borderRadius="full"
                bg={progressBg}
              />
            </Box>
          )}
          
          <Button 
            size="sm" 
            variant="outline" 
            borderColor={buttonBorderColor}
            color={headerColor}
            _hover={{
              borderColor: buttonHoverBorderColor,
              bg: hoverBg
            }}
          >
            {currentPlan === 'premium' ? 'プレミアムプラン' : '無料プラン'}
          </Button>
          
          <IconButton
            aria-label={`Switch to ${colorMode === 'light' ? 'dark' : 'light'} mode`}
            icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
            onClick={toggleColorMode}
            variant="ghost"
            color={headerColor}
            _hover={{
              bg: hoverBg
            }}
            size="sm"
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
